export default "__VITE_ASSET__CL2xGHui__"